/* eslint new-cap: ['error', { 'capIsNew': false }]*/
import React from 'react';
import { connect } from 'react-redux';
import RefPicker from '../../dict/simple/select/DictPicker.jsx';
import { Row, Col, ControlLabel } from 'react-bootstrap';
import {
  FormControl,
  Button,
  Checkbox,
} from '../../form/FormControls.jsx';
import { MainComponentBox, FormGroupWValidation as FormGroup, goBack,
  createFormData } from '@/util/util.jsx';
import { RoleElement } from './RoleElement';
import { loadProfile } from '@/store/allaround.store';
import {
  putError as putErrorAction, removeError as removeErrorAction,
} from '../../../store/error.store';
import { updateProfile as updateProfileAction } from './user.store';
// I'm kinda relying on the fact that the store branch with
// user info is loaded already... shouldn't do this tho

const isEmptyString = s => s == null || s.trim() == '';

export const resolvePasswordValidationError = (value) => {
  if (!value) {
    return 'Password is empty';
  }
  if (value.length != 0 && value.length < 10) {
    return 'Password should be 10 characters or longer';
  }
  const MIN_RULES_TO_ENFORCE = 3;
  let enforced = 0;
  [/[A-Z]/, /[a-z]/, /[0-9]/, /[\W\-_]/].forEach((m) => {
    if (m.test(value)) {
      enforced += 1;
    }
  });
  if (enforced < MIN_RULES_TO_ENFORCE) {
    return 'Password should follow at least ' +
        '3 of the rules: upper case letters, lower case, digits, non-word characters';
  }
  return null;
};

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.onCancel = this.onCancel.bind(this);
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.addPasswordError = this.addPasswordError.bind(this);
    this.roles = [];
    this.state = ({
      submitDisable: true,
    });
  }

  componentWillMount() {
    this.props.loadUserProfile();
  }

  componentWillReceiveProps(props) {
    if (props.user) {
      this.roles = props.user.roles || [];
    }
  }

  onCancel() {
    this.props.cancel();
  }

  onSubmit(event) {
    event.preventDefault();
    const formData = createFormData('profileForm');
    if (formData) {
      if (isEmptyString(formData.newPassword)) {
        this.addPasswordError('New password must be defined');
        return;
      }
      if (isEmptyString(formData.currentPassword)) {
        this.addPasswordError('Current password must be defined');
        return;
      }
      if (isEmptyString(formData.newPasswordConfirmation)) {
        this.addPasswordError('Confirm new password');
        return;
      }
      if (formData.newPassword != formData.newPasswordConfirmation) {
        this.addPasswordError('Password confirmation failed');
        return;
      }
      if (formData.newPassword == formData.currentPassword) {
        this.addPasswordError('New password matches current one');
        return;
      }
      const errorMessage = resolvePasswordValidationError(formData.newPassword);
      if (errorMessage) {
        this.addPasswordError(errorMessage);
      } else {
        formData.password = formData.newPassword;
        delete formData.newPassword;
        delete formData.newPasswordConfirmation;

        this.props.updateProfile(formData);
      }
    }
    if (this.state.roles) {
      formData.roles = this.state.roles.map(r => r.value);
    }
  }

  addPasswordError(message) {
    if (message) {
      this.props.putError({ newPassword: message });
    }
  }

  handleNewPasswordChange(event) {
    const { value } = event.target;
    const errorMessage = resolvePasswordValidationError(value);
    if (errorMessage) {
      this.addPasswordError(errorMessage);
    } else {
      this.props.removeError('newPassword');
    }
    this.setState({ submitDisable: !!errorMessage });
  }

  render() {
    return (<div>{this.props.user == undefined ? '' :
      <form id="userForm" onSubmit={this.onSubmit}>
        <MainComponentBox>
          <Row className={'reference-edit-panel'} style={{ paddingTop: 45 }}>
            <Col xs={12} md={6} lg={5}>
              <div className={'edit-reference-header'}>User profile</div>
              <input type="text" style={{ display: 'none' }} />
              <input type="password" style={{ display: 'none' }} />
              <FormControl
                name="id" type="id" style={{ display: 'none' }}
                defaultValue={this.props.user.id}
              />
              <Row>
                <Col sm={6}>
                  <FormGroup id="firstName">
                    <ControlLabel style={{ height: 'auto' }}>First name</ControlLabel>
                    <FormControl
                      type="text" value={this.props.user.firstName} disabled
                    />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup id="lastName">
                    <ControlLabel style={{ height: 'auto' }}>Last name</ControlLabel>
                    <FormControl
                      type="text" value={this.props.user.lastName} disabled
                    />
                  </FormGroup>
                </Col>
              </Row>


              <FormGroup id="username">
                <ControlLabel style={{ height: 'auto' }}>User name</ControlLabel>
                <FormControl
                  type="text" value={this.props.user.username} disabled
                />
              </FormGroup>
              <FormGroup id="currentPassword">
                <ControlLabel style={{ height: 'auto' }}>Current password</ControlLabel>
                <FormControl
                  type="password" name="currentPassword"
                />
              </FormGroup>
              <Row>
                <Col sm={6}>
                  <FormGroup id="newPassword">
                    <ControlLabel style={{ height: 'auto' }}>New password</ControlLabel>
                    <FormControl
                      type="password" onChange={this.handleNewPasswordChange} name="newPassword"
                    />
                  </FormGroup>
                </Col>
                <Col sm={6}>
                  <FormGroup id="newPasswordConfirmation">
                    <ControlLabel style={{ height: 'auto' }}>
                      New password verified
                    </ControlLabel>
                    <FormControl
                      type="password" name="newPasswordConfirmation"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <FormGroup id="email">
                <ControlLabel style={{ height: 'auto' }}>Email</ControlLabel>
                <FormControl
                  type="text" value={this.props.user.email} disabled
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel style={{ height: 'auto' }}>Roles</ControlLabel>
                <RoleElement
                  roles={this.roles}
                  multi
                  disabled
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel style={{ height: 'auto' }}>Region</ControlLabel>
                <RefPicker
                  updateDefValueOnEveryChange
                  dict="origin" name="origin"
                  defaultValue={parseInt(this.props.user.origin || 0, 10)}
                  disabled
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel style={{ height: 'auto' }}>Enabled</ControlLabel>
                <Checkbox defaultChecked={this.props.user.enabled} disabled />
              </FormGroup>
              <Button
                type="submit" bsStyle="primary" id="saveUser"
                disabled={this.state.submitDisable || this.props.saving}
              >
                  Save
              </Button>
              <Button onClick={this.onCancel} bsStyle="gray">Cancel</Button>
            </Col>
          </Row>
        </MainComponentBox>
      </form>
    }
    </div>);
  }
}
Profile.propTypes = {
  user: React.PropTypes.object,
  cancel: React.PropTypes.func,
  loadUserProfile: React.PropTypes.func,
  saving: React.PropTypes.bool,
  putError: React.PropTypes.func,
  updateProfile: React.PropTypes.func,
  removeError: React.PropTypes.func,
};

const mapStateToProps = state => ({
  saving: state.getIn(['allaround', 'saving'], false),
  user: state.getIn(['allaround', 'profile']),
});

const mapDispatchToProps = (dispatch, props) => ({
  cancel() {
    goBack(props.location.pathname);
  },
  loadUserProfile() {
    loadProfile(dispatch);
  },
  putError(error) {
    putErrorAction(dispatch, error);
  },
  removeError(key) {
    removeErrorAction(dispatch, key);
  },
  updateProfile(userDto) {
    updateProfileAction(dispatch, userDto);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
